<template>
  <div :class="['upload-area', wrongFormat || isOversize ? 'file-error' : '']">
    <el-upload
      :name="name"
      :class="[
        name == 'photo_file' && uploaded ? 'uploaded' : '',
        showTextInfo ? 'el-upload__text' : ''
      ]"
      :ref="'upload' + id"
      action=""
      :auto-upload="false"
      :file-list="notes"
      :list-type="listType"
      :disabled="disabled || file.length == limit"
      :drag="drag"
      :accept="accept"
      :limit="limit"
      :on-change="changeFile"
      :on-remove="removeFile"
      :multiple="multiple"
      :show-file-list="showFileList"
    >
      <p
        v-if="
          showTextInfo &&
          mode != 'import' &&
          listType !== 'picture-card' &&
          listType !== 'picture' &&
          mode != 'import' &&
          mode != 'group' &&
          !isOversize &&
          !isSummeryOversize
        "
        class="content__help secondary"
        slot="tip"
      >
        {{ fileType }} Размер файла не более {{ this.size / 1024 / 1024 }} Мб
      </p>
      <p
        v-if="mode == 'import' && showTextInfo"
        :class="'content__import-text'"
        slot="tip"
      >
        {{ importSubText }}
      </p>
      <p
        v-if="wrongFormat || isOversize || isSummeryOversize"
        class="content__title red"
        v-html="$sanitize(showErrorText)"
        slot="tip"
      ></p>
      <template v-if="!Object.keys($slots).length">
        <div
          class="upload-counter"
          @drop="drop"
          @dragover="dragover"
          @dragleave="dragleave"
        >
          <input type="file" multiple ref="file" style="display: none" />
          <img
            v-if="listType == 'picture-card'"
            src="../../../assets/img/bigEmpty.png"
            width="80"
            height="80"
            class="picture-default"
          />
          <Button
            v-if="listType == 'picture-card'"
            class="content__button"
            buttonText="Загрузить фото"
          />
          <Button
            v-else-if="listType == 'picture'"
            buttonSize="big"
            buttonColor="blue"
            buttonText=""
            hasLeftIcon
            :disabled="disabled || file.length == limit"
            iconName="PictureFrame"
            class="picture-button"
          />
          <div
            v-if="
              !multiple &&
              file[0] &&
              listType != 'picture-card' &&
              listType != 'picture'
            "
            class="single"
          >
            <span>{{ file[0].name }}</span>
            <Button
              class="single__button"
              hasLeftIcon
              iconName="delete"
              buttonColor="transparent"
              @click.stop.prevent="removeFile()"
            />
          </div>
          <div
            v-else-if="listType != 'picture-card' && listType != 'picture'"
            class="multiple"
          >
            <Button buttonSize="big" :buttonText="buttonText" />
            <span>Или перетащите сюда</span>
          </div>
        </div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { errorMsg } from '@/utils/mixins';
import Button from 'Elements/Button/Button';
import { Upload } from 'element-ui';
import isEqual from 'lodash/isEqual';

export default {
  mixins: [errorMsg],
  components: {
    'el-upload': Upload,
    Button
  },
  props: {
    mode: {
      type: String,
      default: ''
    },
    notes: {
      type: [Object, Array],
      default: () => []
    },
    file: {
      type: [Object, Array],
      default: () => (this.file?.hasOwnProperty('length') ? [] : {})
    },
    accept: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'text'
    },
    fileType: {
      type: String,
      default: 'Любой формат.'
    },
    buttonText: {
      type: String,
      default: 'Выберите файл'
    },
    name: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: Infinity
    },
    size: {
      // byte value:
      type: Number,
      default: 20 * 1024 ** 2 // 2e7 or 20Mb
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    showTextInfo: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    drag: {
      type: Boolean,
      default: true
    },
    summarySize: {
      type: Number,
      default: Infinity
    },
    trackFormat: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploaded: false,
      isOversize: false,
      wrongFormat: false,
      newMultiImport: true,
      fileCount: 0,
      totalFilesCount: 0,
      isSummeryOversize: false
    };
  },
  created() {
    if (this.notes.length) {
      this.changeFile();
    }
  },
  methods: {
    drop(event) {
      event.preventDefault();
      this.totalFilesCount = event.dataTransfer.files.length;
      event.currentTarget.classList.remove('is-dragover');
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('is-dragover')) {
        event.currentTarget.classList.add('is-dragover');
      }
    },
    dragleave(event) {
      event.currentTarget.classList.remove('is-dragover');
    },
    currentSummarySize(files) {
      return files.reduce((acc, el) => acc + el.size || 0, 0);
    },
    validateBySummarySize(files) {
      const currentSummarySize = this.currentSummarySize(files);
      const oversize = currentSummarySize <= this.size ? false : true;

      this.isSummeryOversize = oversize;
      this.$emit('oversize', oversize);
    },
    invalidFormatType(formats, files) {
      return files.some(file => {
        const fileType = file.name.split('.').slice(-1).join('');
        return !formats.includes(fileType);
      });
    },
    changeFile() {
      let uploadFiles = this.$refs['upload' + this.id].uploadFiles;
      const newFile = uploadFiles[uploadFiles.length - 1];
      const onlyImageFormats = ['jpg', 'jpeg', 'png'];
      const imageAllFormats = ['jpg', 'jpeg', 'png', 'heic', 'gif', 'svg'];

      if (
        this.accept == 'image/png, image/jpeg, image/jpg' &&
        this.invalidFormatType(onlyImageFormats, uploadFiles)
      ) {
        this.$refs['upload' + this.id].uploadFiles = [];
        this.showErrorMessage(
          'Неверный формат файла. Могут быть загружены только файлы форматов png, jpg, jpeg'
        );
        return;
      }
      if (
        this.accept == 'image/*' &&
        this.invalidFormatType(imageAllFormats, uploadFiles)
      ) {
        this.$refs['upload' + this.id].uploadFiles = [];
        this.showErrorMessage(
          'Неверный формат файла. Могут быть загружены только изображения'
        );
        return;
      }

      if (this.mode == 'import') {
        const fileElems = newFile.name.split('.');
        const format = fileElems[fileElems.length - 1];
        if (!this.multiple) {
          if (this.wrongFormat) this.wrongFormat = false;
          if (newFile.size > this.size) this.isOversize = true;
          if (this.trackFormat && this.trackFormat != format) {
            this.wrongFormat = true;
          } else {
            this.$emit('upload-file', newFile);
          }
        } else {
          if (this.newMultiImport) {
            this.newMultiImport = false;
            this.wrongFormat = false;
            this.isOversize = false;
            this.fileCount = 0;
            this.$emit('new-import');
          }
          this.fileCount++;
          if (
            this.trackFormat &&
            !this.trackFormat.split(',').includes(format)
          ) {
            this.wrongFormat = true;
          }
          if (newFile.size > this.size) this.isOversize = true;
          if (!this.wrongFormat && !this.isOversize)
            document.getElementsByClassName('el-upload__input')[0].files.length
              ? this.$emit('upload-file', newFile)
              : this.$emit('upload-file', newFile, this.totalFilesCount);
          if (
            this.fileCount ==
              document.getElementsByClassName('el-upload__input')[0].files
                .length ||
            this.fileCount == this.totalFilesCount
          ) {
            this.newMultiImport = true;
          }
        }
      } else {
        const validSize = newFile.size < this.size;

        if (this.summarySize < Infinity) {
          this.validateBySummarySize(uploadFiles);

          uploadFiles = uploadFiles.filter((el, i, arr) => {
            const slicedFiles = arr.slice(0, i + 1);
            const currentSummarySize = this.currentSummarySize(slicedFiles);

            if (currentSummarySize <= this.size) {
              if (!this.file.find(elem => elem.uid == el.uid)) {
                this.file.push(el);
              }
              return el;
            }
          });

          this.$refs['upload' + this.id].uploadFiles = uploadFiles;
          this.$emit('upload-file', uploadFiles);
          return;
        }

        if (validSize) {
          this.isOversize = false;
          if (!this.file.find(elem => elem.uid == newFile.uid)) {
            this.file.push(newFile);
            this.uploaded = true;
          }

          // if (this.name === 'filename_file' || this.name === 'resume_file') {
          this.$emit('upload-file', newFile);
          this.$emit('oversize', false);
          // }
        } else {
          this.isOversize = true;
          this.$refs['upload' + this.id].uploadFiles.pop();
          this.$emit('oversize', true);
        }
        //добавляем ссылки на файлы, чтобы их можно было скачать из списка файлов
        this.addDownloadLinks();
      }
    },
    removeFile(file, fileList) {
      this.uploaded = false;
      this.isOversize = false;
      this.$emit('remove-file', file, fileList);
      this.addDownloadLinks();
    },
    addDownloadLinks() {
      setTimeout(() => {
        const uploadFiles = this.$refs['upload' + this.id].uploadFiles;
        const fileNames = document.getElementsByClassName(
          'el-upload-list__item-name'
        );
        for (let i = 0; i < fileNames.length; i++) {
          fileNames[i].href = window.URL.createObjectURL(uploadFiles[i]?.raw);
          fileNames[i].setAttribute('download', uploadFiles[i]?.name);
          fileNames[i].setAttribute('target', '_blank');
        }
      }, 100);
    }
  },
  computed: {
    showErrorText() {
      if (this.multiple) {
        if (this.wrongFormat) return 'Один из файлов имеет неверный формат';
        if (this.isOversize)
          return this.isSummeryOversize
            ? `Размер вложений не более ${this.size / 1024 / 1024} Мб`
            : `Документы не более ${this.size / 1024 / 1024} Мб`;
        if (this.isSummeryOversize) {
          return `Размер вложений не более ${this.size / 1024 / 1024} Мб`;
        } else return '';
      } else {
        if (this.wrongFormat) return 'Неверный формат файла';
        if (this.isOversize)
          return `Документ не более ${this.size / 1024 / 1024} Мб`;
        else return '';
      }
    },
    importSubText() {
      if (this.trackFormat && this.multiple) {
        let formats = this.trackFormat
          .split(',')
          .map(el => el.toUpperCase())
          .join(', ');
        return `файлы не более чем в ${
          this.size / 1024 / 1024
        } МБайт в ${formats} формате`;
      } else return `Шаблоны в ${this.trackFormat.toUpperCase()} формате`;
    }
  },
  watch: {
    'file.length': function () {
      // отслеживаем удаление или добавление
      if (!isEqual(this.file, this.$refs['upload' + this.id].uploadFiles)) {
        this.$refs['upload' + this.id].uploadFiles = this.file;

        if (this.summarySize < Infinity) {
          this.validateBySummarySize(this.file);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-upload {
  & ::v-deep &-dragger {
    border: 2px dashed $blue40;
  }
}

.upload-area {
  & ::v-deep .multiple {
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
  }

  & ::v-deep .el-upload__text {
    height: fit-content !important;
  }

  & ::v-deep .el-upload-list {
    &__item {
      display: flex;
      align-items: center;
      height: 40px;
      background: $grey8;

      & > .el-upload-list__item-status-label {
        display: none;
      }

      & > .el-icon-close {
        top: 8px;

        &::before {
          content: url(/img/cross.svg);
        }
      }

      &-name {
        line-height: 20px;
        color: $grey80;
        padding-left: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-decoration: none;

        & > .el-icon-document {
          display: none;
        }
      }
    }
  }

  p {
    text-align: center;
  }

  span {
    font-size: 14px;
    line-height: 20px;
    color: $grey64;
  }

  ::v-deep .el-upload-dragger {
    height: 72px;
    padding: 16px;
    font-size: 0;

    &:has(.single) {
      background: $grey8;
      border: none !important;
    }

    .single {
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      &__button {
        padding: 0 !important;
        width: 24px;
      }
    }

    & > .multiple {
      gap: 12px;
      display: flex;
      flex-direction: row !important;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
    }

    &.is-dragover {
      font-size: 14px;
      min-height: 76px;

      & > .multiple {
        display: none !important;
      }
    }
  }

  &.file-error ::v-deep .el-upload {
    display: flex;
    flex-direction: column;

    & > .el-upload-dragger {
      border: 2px dashed $red;
      border-radius: 4px; //12
      display: flex;
      height: auto;
      flex-direction: column;
      justify-content: center;
      width: 100%;
    }
  }

  & ::v-deep .el-upload {
    display: flex;
    flex-direction: column;

    &--picture-card {
      margin-bottom: 60px;
      border: none;
      line-height: 0;
      width: 144px;
      height: 144px;

      .el-upload-dragger {
        border: 1px solid $grey16 !important;
        border-radius: 8px !important;
        align-items: center;
        overflow: unset;
        display: block !important;
        padding: 0;

        img {
          margin-top: 32px;
        }

        .content__button {
          top: 32px;
        }
      }
    }

    &__text {
      height: 72px;
    }

    & > .el-upload-dragger {
      border: 2px dashed $blue40;
      border-radius: 4px; //12
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }

  & ::v-deep .el-upload--picture {
    & > .el-upload-dragger {
      padding: 0;
      border: none;
      border-radius: 4px; //12
      display: flex;
      height: auto;
      width: 56px;
    }
  }

  &__content {
    gap: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.content {
  &__title {
    margin-top: 8px !important;
    align-self: center;
    -ms-grid-row-align: center;
    font-size: 15px;
    margin: 0;
    line-height: 24px;
  }

  .picture-default {
    align-self: center;
  }

  &__button {
    margin-top: 12px;
    align-self: center;
    -ms-grid-row-align: center;
  }

  &__error {
    font-size: 14px;
    color: $red-700;
    line-height: 24px;
  }

  &__help {
    font-size: 14px;
    line-height: 20px;
    margin: 8px 0 0 0 !important;
  }

  &__import-text {
    color: $black-100;
    margin-top: 8px;
  }
}

.picture-button {
  &:disabled:hover {
    & ::v-deep * {
      cursor: not-allowed;
    }
  }
}
</style>
